import { useEffect, useState, useMemo } from "react";
import { Button, Icon } from "semantic-ui-react";
import { useNavigate, Link } from "react-router-dom";
import { ReactTable, LoadingWrapper, DefaultColumnFilter, SelectColumnFilter, SelectFilterType } from "../../common";
import { formatDateToMmDdYyyy } from "../../../utils/formatDate";
import PropTypes from "prop-types";
import { useAuth } from "../../auth";

const JSAFormsContent = ({ jsaForms, loaded }) => {
    const [formsArray, setFormsArray] = useState([]);
    const navigate = useNavigate();
    const { isReadOnly } = useAuth();

    useEffect(() => {
        if (jsaForms && typeof jsaForms === "object") {
            const arr = Object.keys(jsaForms).map((formId) => {
                const form = jsaForms[formId];
                return {
                    ...form,
                    formId,
                    status: form.submissionTime == null ? "Draft" : "Submitted"
                };
            });
            setFormsArray(arr);
        } else {
            setFormsArray([]);
        }
    }, [jsaForms]);

    const columns = useMemo(() => [
        {
            Header: "Form ID",
            accessor: "formId",
            Cell: (row) => (
                <Link to={`/forms/jsaform/${row.row.original.formId}`}>{row.row.original.formId}</Link>
            ),
        },
        {
            Header: "Team Name",
            accessor: "teamName",
            Filter: DefaultColumnFilter,
            Cell: (row) => row.row.original.teamName,
        },
        {
            Header: "Date",
            accessor: "date",
            Cell: (row) => formatDateToMmDdYyyy(row.row.original.date),
        },
        {
            Header: "Status",
            accessor: "status",
            Filter: row => SelectColumnFilter(row, ["Draft", "Submitted"]),
            filter: SelectFilterType,
            Cell: (row) => (row.row.original.submissionTime == null ? "Draft" : "Submitted"),
        },
    ], []);

    return (
        <LoadingWrapper loading={!loaded} text="Loading JSA forms">
            <div>
                <ReactTable
                    className="channel-table"
                    data={formsArray}
                    columns={columns}
                    editable={false}
                />
                <div style={{ padding: "1rem 0", display: "flex", justifyContent: "center", width: "100%" }}>
                    {!isReadOnly && (
                        <Button
                            style={{ backgroundColor: "var(--add)", color: "white" }}
                            onClick={() => navigate("/forms/jsaform/new")}
                            icon
                            labelPosition="left"
                        >
                            <Icon name="plus" />
                            Create New JSA Form
                        </Button>
                    )}
                </div>
            </div>
        </LoadingWrapper>
    );
};

JSAFormsContent.propTypes = {
    jsaForms: PropTypes.object,
    loaded: PropTypes.bool,
};

export { JSAFormsContent };
